// extracted by mini-css-extract-plugin
export default {"footerContainer":"AIFeedbackModal__footerContainer___zo3qY","skeleton-loading":"AIFeedbackModal__skeleton-loading___cW2uh"};